export default __webpack_public_path__ + "static/media/HotDropBg.min.50dc9790.png";